import { useEffect } from "react";

export const useCommandPaletteShortcut = (toggle: () => void): void => {
  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      const isK = event.key === "k" || event.key === "K";
      if (!isK || !(event.metaKey || event.ctrlKey)) return;
      event.preventDefault();
      toggle();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [toggle]);
};
